import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useToast } from "../contexts/ToastContext";
import Button from "../components/Button";
import "./scss/seller-auth.scss";

export default function SellerAuthPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [loginValue, setLoginValue] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!loginValue || !password) {
      showToast("Введите ИНН или Email и пароль");
      return;
    }

    try {
      setLoading(true);
      await login("seller", loginValue, password);
      navigate("/seller/dashboard");
    } catch {
      showToast("Неверные данные для входа");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="seller-auth-page">
      <div className="seller-auth-page__container">
        <div className="seller-auth-page__card">

          <div className="seller-auth-page__logo">
            <img src="/images/floyaLogo.png" alt="Floya" />
            <span>Кабинет магазина</span>
          </div>

          <div className="seller-auth-page__form">
            <input
              placeholder="ИНН или Email"
              value={loginValue}
              onChange={(e) => setLoginValue(e.target.value)}
            />

            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Button
              className="btn-primary large"
              onClick={handleSubmit}
              load={loading}
            >
              Войти
            </Button>
          </div>

        </div>
      </div>
    </div>
  );
}
